module.exports = __webpack_public_path__ + "static/media/18ECA28.30217dae.jpg";